import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SettingsProvider } from "./context/SettingsContext";
import { SyncProvider } from "./context/SyncContext";
import { installFetchUnauthorizedGuard } from "./utils/authSession";

// Login
import LoginPage from "./components/LoginPage";

// Admin Dashboard
import DispatcherDashboard from "./components/dispatcher/DispatcherDashboard";

// Dispatcher Panel
import DispatcherPanel from "./components/dispatcher-panel/DispatcherPanel";

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  useEffect(() => {
    const uninstallFetchGuard = installFetchUnauthorizedGuard();
    return () => uninstallFetchGuard();
  }, []);

  return (
    <SettingsProvider>
      <SyncProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Single Login Page */}
              <Route path="/login" element={<LoginPage />} />
              
              {/* Redirect root to login */}
              <Route path="/" element={<Navigate to="/login" replace />} />
              
              {/* Legacy redirects */}
              <Route path="/adiadm" element={<Navigate to="/login" replace />} />
              <Route path="/dispatcher/login" element={<Navigate to="/login" replace />} />
              
              {/* Dispatcher Panel - Simple view for call operators */}
              <Route
                path="/dispatcher/*"
                element={
                  <RequireAuth>
                    <DispatcherPanel />
                  </RequireAuth>
                }
              />
              
              {/* Admin Panel - Full control for administrators */}
              <Route
                path="/admin/*"
                element={
                  <RequireAuth>
                    <DispatcherDashboard />
                  </RequireAuth>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </div>
      </SyncProvider>
    </SettingsProvider>
  );
}

export default App;
